import type { ReactNode } from 'react';
import styles from './Container.module.css';

type TProps = {
  children: ReactNode;
};

export const Container = ({ children }: TProps) => {
  return <div className={styles.container}>{children}</div>;
};
